export default __webpack_public_path__ + "static/media/chimney.31d894b2.svg";